var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMongodb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mongodb-svgrepo-com 1",
    clipPath: "url(#clip0_144_457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M50.5 100C78.1142 100 100.5 77.6142 100.5 50C100.5 22.3858 78.1142 0 50.5 0C22.8858 0 0.5 22.3858 0.5 50C0.5 77.6142 22.8858 100 50.5 100Z",
    fill: "#13AA52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M63.8653 43.8906C60.7071 29.9521 53.2433 25.3691 52.4396 23.6182C51.5606 22.3828 50.67 20.1855 50.67 20.1855C50.6554 20.1484 50.6319 20.083 50.6046 20.0195C50.5138 21.2549 50.4669 21.7314 49.2989 22.9775C47.4903 24.3916 38.211 32.1777 37.4562 48.0137C36.7521 62.7832 48.1251 71.584 49.6632 72.7061L49.838 72.8301V72.8193C49.8478 72.8936 50.3263 76.335 50.6622 79.9814H51.8673C52.15 77.4039 52.5739 74.8437 53.1368 72.3125L53.2345 72.249C53.9225 71.7557 54.5784 71.2191 55.1983 70.6426L55.2687 70.5791C58.5382 67.5586 64.4161 60.5723 64.3585 49.4336C64.3463 47.5755 64.1814 45.7216 63.8653 43.8906ZM50.5343 64.3672C50.5343 64.3672 50.5343 43.6523 51.2179 43.6562C51.7511 43.6562 52.4415 70.376 52.4415 70.376C51.4923 70.2617 50.5343 65.9785 50.5343 64.3672Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_144_457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMongodb);
export default __webpack_public_path__ + "static/media/mongodb.359a36d76b8151f2afd75a4720978441.svg";
export { ForwardRef as ReactComponent };